import React, { useEffect, useState } from 'react';
import { useController } from 'react-hook-form';
import Checkbox from '@components/common/checkbox';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

interface ListItemType {
  isOn?: boolean;
  name?: string;
  code?: number;
  onClick?: () => void;
}

interface CheckboxListItemType {
  isChecked?: boolean;
  name?: string;
  code?: number;
  onChange?: (checked: boolean) => void;
}

interface CheckboxListProps {
  list?: ListItemType[];
  checkboxList?: CheckboxListItemType[];
}

const CheckboxList = ({ list, checkboxList }: CheckboxListProps) => {
  const [selectedField, setSelectedField] = useState<number | null>(null);
  const [initialSetup, setInitialSetup] = useState(false);
  const [selectedCheckboxItems, setSelectedCheckboxItems] = useState<number[]>([]);
  const { field, fieldState } = useController({ name: 'jobGroups' });

  useEffect(() => {
    if (!initialSetup && field.value.length > 0) {
      const initialField = field.value[0].jobGroupCode; // 숫자를 문자열로 변환
      setSelectedField(initialField);

      const initialCheckboxItems = field.value[0].jobTitleCodes.map((code: number) => code); // 숫자를 문자열로 변환
      setSelectedCheckboxItems(initialCheckboxItems);
      setInitialSetup(true);
    }
  }, [field, initialSetup]);
  const handleListItemClick = (code?: number) => {
    if (!code) return;

    setSelectedField((prevSelected) => (prevSelected === code ? null : code));
  };

  const handleCheckboxChange = (checked: boolean, code?: number) => {
    if (!code) return;

    setSelectedCheckboxItems((prevSelected) => {
      if (checked) {
        return [...prevSelected, code];
      } else {
        return prevSelected.filter((item) => item !== code);
      }
    });
  };

  const listEls = list?.map((item, index) => (
    <li
      key={index}
      className={cx('listBtn', { on: selectedField === item.code })}
      onClick={() => {
        item.onClick?.();
        setSelectedCheckboxItems([]);
        handleListItemClick(item.code);
      }}
    >
      {item?.name}
    </li>
  ));
  const checkboxListEls = checkboxList?.map((item, index) => (
    <div key={index} className={cx('checkboxArea', { on: selectedCheckboxItems.includes(item.code || -1) })}>
      <div className={cx('checkboxWrap')}>
        <Checkbox
          checked={selectedCheckboxItems.includes(item.code || -1)}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            item.onChange?.(e.target.checked);
            handleCheckboxChange(e.target.checked, item.code);
          }}
        >
          <span className={cx('label Text')}>{item.name}</span>
        </Checkbox>
      </div>
    </div>
  ));

  return (
    <div className={cx('area')}>
      {/* 직군 */}
      <div className={cx('listArea')}>
        <div className={cx('questionTitle')}>원하는 직군을 알려주세요.</div>
        <ul className={cx('listWrap')}>{listEls}</ul>
      </div>

      {/* 직무 */}
      {selectedField && (
        <div className={cx('checkboxListArea')}>
          <div className={cx('checkboxListWrap')}>
            <div className={cx('questionTitle')}>원하는 직무를 알려주세요.</div>
            <ul className={cx('listWrap')}>{checkboxListEls}</ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckboxList;
